<template>
    <div>
        <div class="row">
            <div class="col-md-5 why-advertise-benefits">
                <h1 class="mb-4 mb-md-5">Vorteile von Erobella-Werbeanzeigen</h1>
                <ul>
                    <li>Es ist <strong>kostenlos!</strong> Einfache Anzeigen sind kostenlos und werden kostenlos
                        bleiben.
                    </li>
                    <li>Letzten Monat sahen <strong>32.643</strong> Kunden Anzeigen auf Erobella</li>
                    <li>Jetzt anmelden & wir schenken dir 2 Wochen Premium - du bist ganz oben in den Suchergebnissen
                    </li>
                    <li>Unser Team kann dein Profil erstellen & verwalten</li>
                </ul>
            </div>
            <div class="d-none d-md-block col-md-6 offset-md-1">
                <picture class="w-100" data-iesrc="images/why-advertise/large.png">
                    <source
                            srcset="/images/why-advertise/large.png, /images/why-advertise/large@2x.png 2x"
                            type="image/jpeg">
                    <img class="w-100" alt=""/>
                </picture>
            </div>
        </div>

        <div class="full-width-grey-bg why-advertise-register py-4 mt-3 mt-md-5">
            <h2 class="text-center mb-3 mb-md-4">Jetzt ein Profil anfordern</h2>
            <form>
                <input v-model="email" class="form-control" type="email" placeholder="Emailadresse eingeben"/>
                <button class="btn btn-primary" type="submit" @click.prevent="requestProfile()">Registrieren</button>
            </form>
        </div>

        <div class="row d-block d-md-none mt-3">
            <div class="col-md-12 d-flex justify-content-center">
                <picture class="mobile-img" data-iesrc="images/why-advertise/small.png">
                    <source
                            srcset="/images/why-advertise/small.png, /images/why-advertise/small@2x.png 2x"
                            type="image/jpeg">
                    <img class="w-100" alt=""/>
                </picture>
            </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="modalWhyAdvertise" tabindex="-1" role="dialog"
             aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">X</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="logo"><img src="/images/logo.svg" alt="logo"/></div>
                        <p>Vielen Dank für die Anmeldung. Jemand wird sich in Kürze mit dir in Verbindung setzen, um dir
                            bei der Erstellung deiner Anzeige zu helfen. Falls du in der Zwischenzeit Fragen hast,
                            schicke uns bitte eine E-Mail an <img src="/images/details/email.png">
                        </p>
                        <p>Wenn du die Anzeige jetzt selbst erstellen möchtest dann</p>
                        <p><a :href="regionRelativeUrl('/users/registration/')">hier klicken</a></p>
                    </div>
                </div>
            </div>
        </div>
        <!-- end Modal -->

    </div>
</template>

<script>

import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";

async function requestProfile() {
    if (this.email) {
        const [err, response] = await to(
            api.user.request_profile({
                email: this.email,
                parameters: _.get(window, 'location.search', ''),
            })
        )

        if (err || !_.get(response, 'data.success', false)) {
            return toastr.error(_.get(this, 'translate.home.errorCommon'));
        }

        $('#modalWhyAdvertise').modal('show');
    }
}

const data = () => {
    return {
        email: null,
    }
};

export default {
    data,
    computed: {
        ...mapState([
            'translate',
        ]),
    },
    methods: {
        requestProfile,
    },
    mixins: [
        regionsUrlMixin,
    ],
    beforeDestroy() {
        $('#modalWhyAdvertise').modal('hide');
    }
};
</script>
